import { IsOptional, IsEnum, IsUUID, IsDateString } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'
import { CampaignStatus, CampaignType } from '../../../enums'

/**
 * DTO for listing campaigns with filters
 */
export class ListCampaignsQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({ enum: CampaignStatus })
  @IsEnum(CampaignStatus)
  @IsOptional()
  status?: CampaignStatus

  @ApiPropertyOptional({ enum: CampaignType })
  @IsEnum(CampaignType)
  @IsOptional()
  type?: CampaignType

  @ApiPropertyOptional({ description: 'Filter by establishment ID' })
  @IsUUID()
  @IsOptional()
  establishmentId?: string

  @ApiPropertyOptional({ description: 'Filter by creator ID' })
  @IsUUID()
  @IsOptional()
  creatorId?: string

  @ApiPropertyOptional({
    description: 'Filter by creator ID (alias for creatorId)',
  })
  @IsUUID()
  @IsOptional()
  createdByUserId?: string

  @ApiPropertyOptional({
    description: 'Date de début de recherche (ISO 8601)',
    example: '2025-11-01T00:00:00Z',
  })
  @IsDateString()
  @IsOptional()
  startDate?: string

  @ApiPropertyOptional({
    description: 'Date de fin de recherche (ISO 8601)',
    example: '2025-11-30T23:59:59Z',
  })
  @IsDateString()
  @IsOptional()
  endDate?: string
}
